exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print{\n.invoice-page *{\n    visibility:hidden\n}\n.invoice-page #content-area{\n    margin:0 !important\n}\n.invoice-page .vs-con-table .vs-con-tbody{\n    overflow:hidden !important\n}\n.invoice-page #invoice-container,.invoice-page #invoice-container *{\n    visibility:visible\n}\n.invoice-page #invoice-container{\n    position:absolute;\n    left:0;\n    top:0;\n    -webkit-box-shadow:none;\n            box-shadow:none\n}\n}\n@page{\n  size:auto\n}", ""]);

// exports
